'use strict'

/**
 * 3M FUSION
 */
import carousel from 'Modules/carousel'
import profileCookie from 'Modules/profileCookie'
import modal from 'Modules/modal'
import responsive from 'Helpers/responsive'

let _app
let validator

/**
 * Builder PopIn3M.
 *
 * Permet l'ajout de la pop in 3M à l'affichage d'une page ou suite à un événement
 *
 * @constructor
 * @param {string} popInSelector - Sélecteur CSS du container de la pop in
 *
 * Par défaut, la pop in s'ouvrira automatiquement et ne forcera pas l'utilisateur à faire le process complet
 */
export class PopIn3M {
    _popInSelector
    _event
    _eventElementSelector
    _openingMode
    _isOpenAuto
    _locationHash
    _showModal
    _redirectUrl
    _showStyleOptions
    _containerClass

    constructor(popInSelector) {
        if (popInSelector == null || popInSelector === '') {
            throw new Error("La pop in 3m n'a pas de sélecteur CSS.")
        }

        this._popInSelector = popInSelector
        this._openingMode = 'AUTO'
        this._isOpenAuto = false
        this._locationHash = ''
        this._showModal = true
        this._redirectUrl = ''
        this._showStyleOptions = true
        this._containerClass = 'jsModalFusion3m'
    }

    /**
     * Définis le type d'événement Javascript
     *
     * Le mode d'ouverture passe à EVENT
     * @param {string} event - Évenement Javascript
     * @returns
     */
    setEvent(event) {
        this._event = event
        this._openingMode = 'EVENT'

        return this
    }

    /**
     * Définis l'élément par son sélecteur CSS sur lequel on attache l'événement
     * @param {string} selector Sélecteur CSS
     * @returns
     */
    setEventElement(selector) {
        this._eventElementSelector = selector

        return this
    }

    /**
     * Définis si la pop in a un process complet (tailles, styles, etc) ou non
     * @param {boolean} isOpenAuto
     * @returns
     */
    setIsOpenAuto(isOpenAuto) {
        this._isOpenAuto = isOpenAuto

        return this
    }

    /**
     * Définis le hash de la page ()
     *
     * Le mode d'ouverture passe à AUTO
     * @param {string} hash
     * @returns
     */
    setLocationHash(hash) {
        this._locationHash = hash
        this._openingMode = 'AUTO'

        return this
    }

    /**
     * Définis si la modal doit s'ouvrir directement
     *
     * @param {boolean} showModal
     * @returns
     */
    setShowModal(showModal) {
        this._showModal = showModal

        return this
    }

    /**
     * Définis si l'url de redirection de la modal
     *
     * @param {string} url
     * @returns
     */
    setRedirectUrl(url) {
        this._redirectUrl = url

        return this
    }

    /**
     * Définis si on affiche le bouton pour plus de style
     *
     * Valeur par défaut : `true`
     *
     * @param {boolean} value
     * @returns
     */
    setShowStyleOptions(value) {
        this._showStyleOptions = value

        return this
    }

    /**
     * Définis si la class Css du container
     *
     * Valeur par défaut : `jsModalFusion3m`
     *
     * @param {boolean} value
     * @returns
     */
    setContainerClass(value) {
        this._containerClass = value

        return this
    }

    /**
     * Build la pop in
     */
    build() {
        // Ouverture automatique
        if (
            (this._openingMode == 'AUTO' && this._locationHash === '') ||
            (this._openingMode == 'AUTO' && this._locationHash === window.location.hash)
        ) {
            if (this.isAppAlreadyMounted()) {
                window.dispatchEvent(new Event('tutorial_begin'))
                $(this._popInSelector).modal()
                return
            }

            if (this.isModalContentAlreayLoaded()) {
                this.init()
                return
            }

            const _self = this

            modal.miseAjourParClassCss(
                _self._containerClass,
                window.location.origin +
                    '/home/LoadModalQuizz?culture=' +
                    $('html').attr('lang') +
                    '&isMobile=' +
                    responsive.isMobile(),
                function () {
                    _self.init()
                }
            )
        }

        // Ouverture par événément
        if (this._event != null && this._openingMode === 'EVENT') {
            const _self = this

            if ($(_self._eventElementSelector).hasClass('prevent-click')) {
                return
            }

            $(_self._eventElementSelector).on(_self._event, function (e, genre) {
                if (_self.isAppAlreadyMounted() || _self.isModalContentAlreayLoaded()) {
                    window.dispatchEvent(new Event('tutorial_begin'))
                    $(_self._popInSelector).modal()

                    if (_app) {
                        _app.SelectionnerGenre(genre)
                    }
                    return
                }

                modal.miseAjourParClassCss(
                    _self._containerClass,
                    window.location.origin +
                        '/home/LoadModalQuizz?culture=' +
                        $('html').attr('lang') +
                        '&isMobile=' +
                        responsive.isMobile(),
                    function () {
                        _self.init(genre)
                        window.dispatchEvent(new Event('tutorial_begin'))
                        $(_self._popInSelector).modal()
                    }
                )
            })
        }

        return this
    }

    isAppAlreadyMounted() {
        if ($(this._popInSelector).get(0) == null) {
            return false
        }

        return $(this._popInSelector).get(0).__vue__ != null
    }

    isModalContentAlreayLoaded() {
        return $(this._popInSelector + ' #formProfilFusion3m').get(0) != null
    }

    checkConditionsToOpenModal() {
        const isCookieSet =
            document.cookie.split('; ').filter((x) => x.startsWith('3MT') || x.startsWith('3MM'))
                .length !== 0

        const showModal = $(this._popInSelector).data('showmodal')

        if (isCookieSet || !showModal) {
            return
        }

        const now = new Date()

        now.setTime(now.getTime() + 1 * 3600 * 1000)

        // Enregistrement du cookie 3M
        document.cookie =
            '3MT=1;domain=' + window.location.hostname + ';expires=' + now.toUTCString() + ';path=/'

        // Affichage de la pop in
        setTimeout(() => {
            $(this._popInSelector).modal({
                backdrop: 'static',
                keyboard: false
            })
        }, 1000)
    }

    init(genre) {
        LaunchApp(this._popInSelector, this._redirectUrl)
        _app.InitData()
        _app.ChargerInformations(genre)
        _app.openAuto = this._isOpenAuto
        _app.SetShowStyleOptions(this._showStyleOptions)

        $(this._popInSelector).on('show.bs.modal', function () {
            window.dispatchEvent(new Event('tutorial_begin'))
            _app.SetIsModalOpen()
        })

        $(this._popInSelector).on('hide.bs.modal', function () {
            $('body').css('overflow', 'auto')
            _app.ResetModal()
        })

        $(this._popInSelector).on('success.form.bv', function (e) {
            e.preventDefault()
        })

        const self = this

        // AB TASTY
        if (!this._showModal) {
            $(this._popInSelector).on('hide.bs.modal', function () {
                // Suppression des carousel Slick
                $('.j_pq_liste_tailles').each(function (index, item) {
                    $(item).slick('unslick')
                })
                $('.j_fusion3m_tailles').each(function (index, item) {
                    $(item).slick('unslick')
                })
                // Suppression du contenu de la modal
                $(self._popInSelector).remove()
            })

            this.checkConditionsToOpenModal()
        }

        if (this._showModal) {
            $(this._popInSelector).modal()
        }
    }

    open(genre) {
        if (this._openingMode == 'AUTO') {
            return
        }
        $(this._eventElementSelector).trigger(this._event, [genre])
    }
}

/**
 * Méthode qui initialise le composant Vue
 * @param {string} appId Id du composant Vue
 * @param {string} redirectUrl Url de redirection
 */
function LaunchApp(appId, redirectUrl = null) {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')

    const urlAPP = window.location.origin

    function onMouseDown(evt) {
        const myinput = $(evt.target).parent('label').siblings('input').attr('id')
        const element = $(evt.target).parent().children('svg')

        if ($('#' + myinput).is(':checked')) {
            element[0].classList.remove('noscale-nocheck')
            element[0].classList.add('scale-check')
            element[0].classList.remove('noscale-check')
        } else {
            element[0].classList.remove('noscale-check')
            element[0].style.opacity = '1'
            element[0].classList.add('scale-nockeck')
            element[0].classList.remove('noscale-nocheck')
        }
    }

    function onMouseUp(evt) {
        const myinput = $(evt.target).parent('label').siblings('input').attr('id')
        const element = $(evt.target).parent().children('svg')
        if ($('#' + myinput).is(':checked')) {
            element[0].classList.add('noscale-check')
            element[0].classList.remove('scale-check')
        } else {
            element[0].classList.add('noscale-nocheck')
            element[0].classList.remove('scale-nockeck')
        }
        element[0].style = ''
    }

    Vue.directive('mouseclass', {
        bind: function (el) {
            el.addEventListener('mousedown', onMouseDown)
            el.addEventListener('mouseup', onMouseUp)
        },
        unbind: function (el) {
            // remove the event handlers
            el.removeEventListener('mousedown', onMouseDown)
            el.removeEventListener('mouseup', onMouseUp)
        }
    })

    _app = new Vue({
        el: appId,
        data: function () {
            return {
                appId: appId.replace('#', ''),
                openAuto: true,
                isActiveCarrouselTaille: false,
                step: 1,
                subStep: 0,
                informations: null,
                informationsStep: null,
                isActiveSubStep: false,
                form: this.InitForm(),
                erreur: null,
                isActiveBtnPrecedent: false,
                isActiveBtnSuivant: true,
                libelleEtapeSuivante: $t('SUIVANT'),
                classEtapeSuivante: '',
                libelleEtapePrecedente: $t('NAVIGATION_PRECEDENT'),
                univers_marketing: '',
                marques_marketing: '',
                erreurTaille: false,
                isSizeonly: false,
                isLoading: false,
                messageErreur: '',
                messageSucces: '',
                redirect: true,
                showSizes: false,
                showStyleOptions: true,
                redirectUrl,
                isModalOpen: false,
                isOTPForm: false,
                otp: null
            }
        },
        updated: function () {
            this.$nextTick(function () {
                // Réinitialise l'affichage des tailles
                if (this.step === 1) {
                    this.showSizes = false
                }

                if (this.openAuto && !this.isModalOpen) {
                    return
                }

                if (this.step !== 2 || this.showSizes) {
                    return
                }

                this.SetTaillesParDefaut()
            })
        },
        computed: {
            IntroFormOTP() {
                if (!this.form.email) {
                    return ''
                }

                return $t('CODE_ENVOYER_PAR_EMAIL').replace('{0}', this.form.email)
            }
        },
        methods: {
            InitData: function () {
                this.openAuto = true
                this.isActiveCarrouselTaille = false
                this.step = 1
                this.subStep = 0
                this.informations = null
                this.informationsStep = null
                this.isActiveSubStep = false
                this.form = this.InitForm()
                this.erreur = null
                this.isActiveBtnPrecedent = false
                this.isActiveBtnSuivant = true
                this.libelleEtapeSuivante = $t('SUIVANT')
                this.libelleEtapePrecedente = $t('NAVIGATION_PRECEDENT')
                this.univers_marketing = ''
                this.marques_marketing = ''
                this.erreurTaille = false
                this.isSizeonly = false
                this.redirect = true
                this.isOTPForm = false
            },
            InitForm: function () {
                const data = {
                    genre: null,
                    categories: [],
                    univers: [],
                    tailles: [],
                    email: null
                }

                return data
            },
            SelectionnerGenre(genre) {
                if (genre) {
                    this.form.genre = genre
                }
                this.GetGenreSizesFromCookie()
                this.EtapeSuivante()
            },
            ChangerStep(step, isBack) {
                const _self = this
                const isABTasty = !isBack && _self.openAuto

                if (_self.informations == null) {
                    return
                }
                switch (step) {
                    case 1:
                        if (_self.form.genre) {
                            _self.EtapeSuivante()
                            return
                        }
                        break
                    case 2:
                        if (isABTasty) {
                            this.LoadInformationsStep()
                            return
                        }

                        if (_self.VerifyTaille()) {
                            _self.EtapeSuivante()
                            return
                        }

                        this.LoadInformationsStep()

                        break
                    case 3:
                        if (_self.VerifyCategorie() && !isBack) {
                            _self.isActiveSubStep = false
                            _self.EtapeSuivante()
                            return
                        }
                        _self.informationsStep = _self.informations.LG.find(function (g) {
                            if (g.R == _self.form.genre) {
                                return true
                            } else {
                                return false
                            }
                        }).LF

                        break

                    case 4:
                        _self.informationsStep = _self.informations.LG.find(function (g) {
                            if (g.R == _self.form.genre) {
                                return true
                            } else {
                                return false
                            }
                        }).LU

                        if (_self.form.genre == 'FEMME') {
                            for (let i = 0; i < _self.informationsStep.length; i++) {
                                if (_self.informationsStep[i].R == 'INTEMPORELLE') {
                                    _self.informationsStep[i].LM[0].L = 'Caroll'
                                    _self.informationsStep[i].LM[1].L = 'Mexx ...'
                                }
                                if (_self.informationsStep[i].R == 'LUXE') {
                                    _self.informationsStep[i].LM[0].L = 'Armani'
                                    _self.informationsStep[i].LM[1].L = 'Maxmara ...'
                                }
                                if (_self.informationsStep[i].R == 'TENDANCE') {
                                    _self.informationsStep[i].LM[0].L = 'Mango'
                                    _self.informationsStep[i].LM[1].L = 'Only ...'
                                }
                                if (_self.informationsStep[i].R == 'ELEGANTE') {
                                    _self.informationsStep[i].LM[0].L = 'Christine Laure'
                                    _self.informationsStep[i].LM[1].L = 'Weill ...'
                                }
                                if (_self.informationsStep[i].R == 'ORIGINAL') {
                                    _self.informationsStep[i].LM[0].L = 'Desigual'
                                    _self.informationsStep[i].LM[1].L = 'Diplodocus ...'
                                }
                                if (_self.informationsStep[i].R == 'SPORTSWEAR') {
                                    _self.informationsStep[i].LM[0].L = 'Adidas'
                                    _self.informationsStep[i].LM[1].L = 'Nike ...'
                                }
                                if (_self.informationsStep[i].R == 'ROCK') {
                                    _self.informationsStep[i].LM[0].L = 'IKKS'
                                    _self.informationsStep[i].LM[1].L = 'Diesel ...'
                                }
                                if (_self.informationsStep[i].R == 'BOHEME') {
                                    _self.informationsStep[i].LM[0].L = 'La Fée Maraboutée'
                                    _self.informationsStep[i].LM[1].L = 'One Step ...'
                                }
                                if (_self.informationsStep[i].R == 'STREETWEAR') {
                                    _self.informationsStep[i].LM[0].L = 'Carhartt'
                                    _self.informationsStep[i].LM[1].L = 'Vans ...'
                                }
                            }
                        } else {
                            for (let j = 0; j < _self.informationsStep.length; j++) {
                                if (_self.informationsStep[j].R == 'LUXE') {
                                    _self.informationsStep[j].LM[0].L = 'Calvin klein'
                                    _self.informationsStep[j].LM[1].L = 'Hugo Boss ...'
                                }
                                if (_self.informationsStep[j].R == 'TENDANCE') {
                                    _self.informationsStep[j].LM[0].L = 'Jack&Jones'
                                    _self.informationsStep[j].LM[1].L = 'Selected ...'
                                }
                                if (_self.informationsStep[j].R == 'ROCK') {
                                    _self.informationsStep[j].LM[0].L = 'Teddy Smith'
                                    _self.informationsStep[j].LM[1].L = 'Diesel ...'
                                }
                                if (_self.informationsStep[j].R == 'SPORTSWEAR') {
                                    _self.informationsStep[j].LM[0].L = 'Adidas'
                                    _self.informationsStep[j].LM[1].L = 'Nike ...'
                                }
                                if (_self.informationsStep[j].R == 'INTEMPORELLE') {
                                    _self.informationsStep[j].LM[0].L = 'Esprit'
                                    _self.informationsStep[j].LM[1].L = 'Gant ...'
                                }
                                if (_self.informationsStep[j].R == 'STREETWEAR') {
                                    _self.informationsStep[j].LM[0].L = 'Carhartt'
                                    _self.informationsStep[j].LM[1].L = 'Obey ...'
                                }
                            }
                        }
                        break
                }
            },
            VerifyTaille: function () {
                const _self = this

                const infos = _self.informations.LG.find(function (g) {
                    return g.R == _self.form.genre
                })

                const taillesNature = infos?.LT
                const tailles = _self.form.tailles

                if (!taillesNature) {
                    return false
                }

                let test = true

                taillesNature.forEach((tailleNature) => {
                    test &= tailleNature.LT.map((x) => x.R).some((e) => tailles.includes(e))
                })

                return Boolean(test)
            },

            VerifyCategorie: function () {
                const _self = this

                if (!_self.openAuto) {
                    return false
                }

                const infos = _self.informations.LG.find(function (g) {
                    return g.R == _self.form.genre
                })

                if (infos && infos.Profile.categories.length > 0) {
                    return true
                }

                return false
            },
            ChargerInformations: function (genre) {
                const _self = this

                _self.form.genre = document.getElementById(_self.appId).dataset.genre ?? genre

                _self.redirect = document.getElementById(_self.appId).dataset.redirect

                fetch(urlAPP + '/PersonnalShopping/GetQuizzFusion3M/', {
                    method: 'GET'
                })
                    .then(function (response) {
                        return response.json()
                    })
                    .then(function (data) {
                        _self.informations = data

                        const profile = _self.informations.LG.find(function (g) {
                            return g.R == _self.form.genre
                        })?.Profile

                        if (profile) {
                            _self.form.categories = profile.categories
                            _self.form.univers = profile.univers
                            _self.form.tailles = profile.tailles
                        }

                        _self.ChangerStep(_self.step, false)
                    })
            },
            EtapePrecedente: function () {
                this.erreurTaille = false

                if (this.isActiveSubStep && this.subStep > 0) {
                    this.subStep--
                } else {
                    this.step--
                }
            },
            EtapeSuivante: function () {
                const _self = this
                this.erreurTaille = false

                switch (this.step) {
                    case 1:
                        if (this.form.genre == null || this.form.genre == 'null') {
                            return
                        }
                        break

                    case 2:
                        if (!this.VerifyTaille()) {
                            this.erreurTaille = true
                            return
                        }
                        break

                    case 4:
                        if (this.informations.IsConnected) {
                            this.Enregistrer()
                            return
                        }
                        break
                    case 5:
                        if (!this.informations.IsConnected) {
                            this.Enregistrer()
                            return
                        }
                        break
                }

                var info = this.informations.LG.find(function (g) {
                    if (g.R == _self.form.genre) {
                        return true
                    } else {
                        return false
                    }
                })

                if (this.isActiveSubStep && this.subStep < info.LF.length - 1) {
                    this.subStep++
                } else {
                    this.step++
                }
            },
            SaveSize: function () {
                const _self = this

                _self.isSizeonly = true

                if (!this.VerifyTaille()) {
                    this.erreurTaille = true
                    return
                }

                if (!_self.informations.IsConnected) {
                    _self.step = 5
                } else {
                    _self.EnregistrerPartiel()
                    _self.ReloadPage()
                    $(`.${_self.appId}`).modal('hide')
                }
            },
            ChangeSize(value) {
                var infoValue = value.split('|')

                var _tailles = {}

                this.form.tailles.forEach((taille) => {
                    var infos = taille.split('|')

                    if (!_tailles.hasOwnProperty(infos[1])) {
                        _tailles[infos[1]] = [taille]
                    } else {
                        _tailles[infos[1]].push(taille)
                    }
                })
                profileCookie.deleteCookie()
                profileCookie.saveDataAsCookie(
                    this.form.genre,
                    this.form.genre,
                    _tailles,
                    infoValue[1]
                )
            },
            EnregistrerPartiel: function () {
                const _self = this

                if (!_self.informations.IsConnected) {
                    return
                }

                const requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    body: JSON.stringify(this.form)
                }

                fetch(urlAPP + '/PersonnalShopping/EnregistrerFusion3M/', requestOptions)
                    .then(function (response) {
                        if (!response.ok) {
                            throw Error(response.statusText)
                        }
                        return response.json()
                    })
                    .catch(function (error) {
                        _self.erreur = error
                    })
            },
            Enregistrer() {
                if (this.isOTPForm) {
                    this.ValiderOTP()
                    return
                }

                const _self = this

                let sendForm = true

                if (!_self.informations.IsConnected) {
                    if (!validator) {
                        $('#formProfilFusion3m').bootstrapValidator()
                        validator = $('#formProfilFusion3m').data('bootstrapValidator')
                    }

                    if (_self.messageErreur != '') {
                        validator.updateStatus(
                            $('#formEmailProfil3M'),
                            'NOT_VALIDATED',
                            'emailAddress'
                        )
                        validator.updateMessage(
                            $('#formEmailProfil3M'),
                            'emailAddress',
                            _self.messageErreur
                        )
                    }

                    sendForm = false
                    validator.validate()
                    if (validator.isValid()) {
                        sendForm = true
                    }
                }

                if (!sendForm) {
                    return
                }

                _self.isActiveBtnSuivant = false
                _self.isLoading = true
                window.dispatchEvent(new Event('tutorial_email'))
                const requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    body: JSON.stringify(this.form)
                }

                fetch(urlAPP + '/PersonnalShopping/Enregistrer/', requestOptions)
                    .then(function (response) {
                        if (!response.ok) {
                            throw Error(response.statusText)
                        }
                        return response.json()
                    })
                    .then(function (r) {
                        if (r.hasCompteClient) {
                            _self.InitOTPForm()
                            return
                        }

                        if (!r.isOK) {
                            throw Error(r.message)
                        }

                        if (r.TagScripts !== undefined && r.TagScripts != '') {
                            try {
                                eval(r.TagScripts)
                            } catch (error) {
                                console.error(error)
                            }
                        }

                        _self.ReloadPage()
                    })
                    .catch(function (error) {
                        _self.isLoading = false
                        _self.isActiveBtnSuivant = true
                        _self.erreur = error

                        if (validator && !_self.informations.IsConnected) {
                            validator.updateStatus(
                                $('#formEmailProfil3M'),
                                'INVALID',
                                'emailAddress'
                            )
                            _self.messageErreur = validator.getMessages(
                                $('#formEmailProfil3M'),
                                'emailAddress'
                            )[0]

                            validator.updateMessage(
                                $('#formEmailProfil3M'),
                                'emailAddress',
                                error.message
                            )
                        }
                    })
            },
            ReloadPage() {
                const _self = this

                if (_self.redirectUrl) {
                    window.location.href = _self.redirectUrl
                    return
                }

                if (!_self.redirect) {
                    location.reload()
                    return
                }

                if (!_self.form.genre) {
                    return
                }

                let url = ''

                switch (_self.form.genre) {
                    case 'HOMME':
                        url = '/articles/homme/'
                        break

                    case 'FEMME':
                        url = '/articles/femme/'
                        break

                    case 'GARCON':
                        url = '/articles/garcon/'
                        break

                    case 'FILLE':
                        url = '/articles/fille/'
                        break
                }

                if (!this.openAuto) {
                    url += '?sp=1'
                }

                window.location.href = urlAPP + url
            },
            ResetModal() {
                if (this.openAuto) {
                    return
                }
                this.step = 1
                this.subStep = 1
                this.form.tailles = []
                this.form.email = null
                this.isOTPForm = false
            },
            GetGenreSizesFromCookie() {
                const profilesCookie = profileCookie.getProfiles()

                const genreProfileCookie = profilesCookie.find((x) => x.gender === this.form.genre)

                // Genre différent ou pas de tailles enregistré
                if (!genreProfileCookie || Object.keys(genreProfileCookie.sizes).length === 0) {
                    return
                }

                // Reduce en un tableau de tailles
                this.form.tailles = Object.values(genreProfileCookie.sizes).reduce(
                    (acc, elem) => (acc = [...acc, ...elem]),
                    []
                )
            },
            SetShowStyleOptions(value) {
                this.showStyleOptions = value
            },
            SetIsModalOpen() {
                if (this.isModalOpen) {
                    return
                }

                this.isModalOpen = true

                if (this.openAuto) {
                    this.SetTaillesParDefaut()
                }
            },
            SetTaillesParDefaut() {
                const genre = this.form.genre.toLowerCase()

                const clickNTimesOnElement = (el, n) => {
                    for (let i = 1; i <= n; i++) {
                        el.slick.slickNext()
                    }
                }

                document.querySelectorAll(`#${this.appId} .slick-slider`).forEach((el, index) => {
                    switch (genre) {
                        case 'femme': {
                            // TAILLES LINGERIE
                            if (index === 3) {
                                clickNTimesOnElement(el, 5)
                                return
                            }

                            clickNTimesOnElement(el, 1)
                            break
                        }
                        case 'homme': {
                            // POINTURE
                            if (index === 2) {
                                clickNTimesOnElement(el, 2)
                                return
                            }

                            clickNTimesOnElement(el, 1)
                            break
                        }
                        case 'fille':
                        case 'garcon':
                            // AGE
                            if (index === 0) {
                                clickNTimesOnElement(el, 3)
                                if (genre === 'garcon') {
                                    clickNTimesOnElement(el, 1)
                                }
                                return
                            }

                            // POINTURE
                            if (index === 1) {
                                clickNTimesOnElement(el, 5)
                            }
                            break
                        default:
                            break
                    }
                })

                setTimeout(() => {
                    this.showSizes = true
                }, 400)
            },
            LoadInformationsStep() {
                const _self = this

                _self.informationsStep = _self.informations.LG.find(
                    (x) => x.R === _self.form.genre
                ).LT

                _self.$nextTick(function () {
                    _self.isActiveCarrouselTaille = true
                    carousel.activerCarrouselTaille()
                })
            },
            GetSlideStep(natureLibelle) {
                return natureLibelle.includes('Lingerie') ? 4 : 2
            },
            InitOTPForm() {
                this.isLoading = false
                this.isActiveBtnSuivant = true
                this.isOTPForm = true
                validator.destroy()
                validator = null
            },
            ClearMessage() {
                this.messageErreur = ''
                this.messageSucces = ''
            },
            ModifierEmailOTP() {
                this.ClearMessage()
                this.isOTPForm = false
                this.otp = null
            },
            ValiderOTP() {
                if (!this.otp) {
                    return
                }

                this.ClearMessage()

                this.isLoading = true

                fetch('/PersonnalShopping/ValidateOTP', {
                    method: 'POST',
                    headers: myHeaders,
                    body: JSON.stringify({ code: this.otp.trim() })
                })
                    .then(function (response) {
                        if (!response.ok) {
                            throw Error(response.statusText)
                        }
                        return response.json()
                    })
                    .then((r) => {
                        if (!r.Ok) {
                            switch (r.CodeErreur) {
                                case 'NotMatch':
                                    this.messageErreur = $t('CODE_SAISI_PAS_VALIDE')
                                    break
                                case 'CodeExpired':
                                    this.messageErreur = $t('CODE_EXPIRE')
                                    break
                                case 'TooManyRetry':
                                    this.messageErreur = $t('TROP_DE_TENTATIVES')
                                    break
                                default:
                                    this.messageErreur = $t('AJAXLOADERINTERNALERROR')
                            }
                            this.isLoading = false
                            return
                        }

                        this.ReloadPage()
                    })
                    .catch((error) => {
                        this.messageErreur = error
                        this.isLoading = false
                    })
            },
            RenvoyerCodeOTP() {
                if (!this.form.email) {
                    return
                }

                this.ClearMessage()

                this.isLoading = true

                fetch('/PersonnalShopping/GenerateNewOTP', {
                    method: 'POST',
                    headers: myHeaders,
                    body: JSON.stringify({ email: this.form.email })
                })
                    .then(function (response) {
                        if (!response.ok) {
                            throw Error(response.statusText)
                        }
                        return response.json()
                    })
                    .then((r) => {
                        if (!r.isOk) {
                            this.messageErreur = $t('ERREUR_ENVOI_CODE')
                            return
                        }

                        this.messageSucces = $t('NOUVEAU_CODE_ENVOYE')
                    })
                    .catch((error) => {
                        this.messageErreur = error
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            }
        },
        watch: {
            step: function (newValue, oldValue) {
                this.informationsStep = null
                this.IsConnected = false
                this.isActiveBtnPrecedent = true
                this.isActiveBtnSuivant = true
                this.isActiveSubStep = false
                this.libelleEtapeSuivante = $t('SUIVANT')
                this.classEtapeSuivante = 'abtEtape' + newValue
                switch (newValue) {
                    case 1:
                        this.isActiveBtnPrecedent = false
                        this.isActiveBtnSuivant = true
                        break

                    case 3:
                        this.isActiveSubStep = true
                        break

                    case 4:
                        if (this.informations.IsConnected) {
                            this.IsConnected = true
                            this.libelleEtapeSuivante = $t('SESAME_OUVRE_TOI')
                        }
                        break

                    case 5:
                        if (!this.informations.IsConnected) {
                            if (this.libelleEtapeSuivante != $t('SESAME_OUVRE_TOI')) {
                                if (this.isSizeonly) {
                                    window.dispatchEvent(new Event('tutorial_complete'))
                                } else {
                                    window.dispatchEvent(new Event('tutorial_full'))
                                }
                            }
                            this.IsConnected = true
                            this.libelleEtapeSuivante = $t('SESAME_OUVRE_TOI')
                        }
                        break
                }
                if (this.step > 2) {
                    this.EnregistrerPartiel()
                }

                this.ChangerStep(newValue, newValue <= oldValue)
            }
        }
    })
}
